import React, { useState, useEffect, useContext } from "react";
import { styled, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Drawer,
  CssBaseline,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
} from "@mui/material";

import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Store as StoreIcon,
  Person as PersonIcon,
  LocalAtm,
  AssessmentSharp,
} from "@mui/icons-material";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import verifyToken from "../../api/user/verifyToken";
import { AuthContext } from "../../context/AuthContext";
import api from "../../api/api";
import { useNavigate, Outlet } from "react-router-dom";
const drawerWidth = 200;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  color: "white",
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function ManagePage() {
  const [open, setOpen] = React.useState(false);
  const [openStores, setOpenStores] = useState(false); // State to control collapse
  const [openUsers, setOpenUsers] = useState(false); // State to control collapse
  const [openTitle, setOpenTitle] = useState("");

  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const userContext = useContext(AuthContext);
  const navigate = useNavigate();
  const title = "內容管理系統";
  const stores = "店家管理";
  const customers = "會員管理";
  const role = {
    Admin: "Admin",
    Moderator: "Moderator",
    RegularUser: "RegularUser",
    Support:"Support"
  };
  const theme = useTheme();
  theme.palette.background.default = "#ffffff";
  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (storedToken !== "" && storedToken !== null) {
      setToken(storedToken);
    }
    if (
      userContext.user === null ||
      (userContext.user?.Role !== role.Admin &&
        userContext.user?.Role !== role.Moderator&&userContext.user?.Role !== role.Support)
    ) {
      navigate("/login");
    }
  }, []);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const responseData = await verifyToken();
        if (responseData.code === "000") {
          userContext.setUser(responseData.user);
        } else {
          userContext.setUser(null);
          localStorage.removeItem("token");
          api.defaults.headers.common["Authorization"] = "";
        }
      } catch (err) {
        userContext.setUser(null);
        localStorage.removeItem("token");
        api.defaults.headers.common["Authorization"] = "";
      } finally {
        setLoading(false);
      }
    };

    if (token !== "" && token !== null) {
      fetchUser();
    }
  }, [token]);
  useEffect(() => {
    if (userContext.user) {
      localStorage.setItem("user", JSON.stringify(userContext.user));
    }
  }, [userContext.user]);

  const webItem = {
    title: "網頁設定",
    navigate: "/dashboard/web/setting",
    subItems: [],
  };
  const storesItem = {
    title: "店家管理",
    navigate: "/dashboard/store/new",
    subItems: [],
  };
  const tableItem = {
    title: "包廂管理",
    navigate: "/dashboard/store/tables",
    subItems: [],
  };
  const usersItem = {
    title: "會員查詢",
    navigate: "/dashboard/user/query",
    subItems: [],
  };
  const couponsItem = {
    title: "優惠券管理",
    navigate: "/dashboard/coupon/new",
    subItems: [],
  };
  const reportItem = {
    title: "統計報表",
    navigate: "/dashboard/report",
    subItems: [],
  };
  const permissionItem = {
    title: "權限管理",
    navigate: "/dashboard/permission",
    subItems: [],
  };

  const handleTitleClick = (title) => {
    if (openTitle === title) {
      setOpenTitle("");
    } else {
      setOpenTitle(title);
    }
  };
  const handleStoresClick = () => {
    setOpenStores(!openStores);
  };
  const handleUsersClick = () => {
    setOpenUsers(!openUsers);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  function logout() {
    // Remove the token from localStorage

    localStorage.removeItem("token");
    userContext.setUser(null);
    navigate("/login");
  }
  const DrawerItem = ({ itemData, icon }) => {
    return itemData?.subItems.length === 0 ? (
      <Button
        variant="text"
        sx={{ fontSize: 16, justifyContent: "left", width: "100%" }}
        startIcon={icon}
        onClick={() => {
          handleTitleClick(itemData.title);
          navigate(itemData?.navigate);
        }}
      >
        {itemData.title}
      </Button>
    ) : (
      <>
        <Button
          variant="text"
          sx={{ fontSize: 16, justifyContent: "left", width: "100%" }}
          startIcon={icon}
          endIcon={
            openTitle === itemData.title ? <ExpandLess /> : <ExpandMore />
          }
          onClick={() => {
            handleTitleClick(itemData.title);
          }}
        >
          {itemData.title}
        </Button>

        <Collapse
          in={openTitle === itemData.title}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {itemData?.subItems.map((subItem, index) => (
              <ListItem
                key={"drawerItem" + index}
                disablePadding
                sx={{ pl: 1 }}
              >
                <ListItemButton
                  sx={{ color: "white" }}
                  onClick={() => navigate(subItem.navigate)}
                >
                  {index + 1 + ". " + subItem.title}
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#f7f7f5",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <CssBaseline />
        <Button
          variant="contained"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          color="secondary"
          sx={{ fontSize: 30, ...(open && { display: "none" }) }}
        >
          {">"}
        </Button>
        <Drawer
          sx={{
            width: drawerWidth,

            "& .MuiDrawer-paper": {
              background: "transparent",
              width: drawerWidth,
              border: "none",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <List
            sx={{
              display: "flex", // Set the list as a flex container
              flexDirection: "column", // Arrange items vertically
              justifyContent: "space-between", // Space between items, pushing the last item to the bottom
              border: 20,
              width: drawerWidth,
              borderRadius: 5,
              height: "98vh",
              margin: 1,

              borderColor: "transparent",
              backgroundColor: "#383838",
              position: "fixed",
            }}
          >
            <div>
              <DrawerHeader>
                {title}
                <IconButton onClick={handleDrawerClose}>
                  {theme.direction === "ltr" ? (
                    <ChevronLeftIcon color="primary" />
                  ) : (
                    <ChevronRightIcon color="primary" />
                  )}
                </IconButton>
              </DrawerHeader>
              {userContext.user?.Role === "Admin" ? (
                <>
                  {" "}
                  <DrawerItem itemData={webItem} icon={<StoreIcon />} />
                  <DrawerItem itemData={storesItem} icon={<StoreIcon />} />
                  <DrawerItem
                    itemData={tableItem}
                    icon={<TableRestaurantIcon />}
                  />
                  <DrawerItem itemData={usersItem} icon={<PersonIcon />} />
                  <DrawerItem itemData={couponsItem} icon={<LocalAtm />} />
                  <DrawerItem
                    itemData={reportItem}
                    icon={<AssessmentSharp />}
                  />
                  <DrawerItem itemData={permissionItem} icon={<PersonIcon />} />
                </>
              ) : userContext.user?.Role === "Moderator" ? (
                <>
                  {" "}
                  <DrawerItem
                    itemData={tableItem}
                    icon={<TableRestaurantIcon />}
                  />
                  <DrawerItem
                    itemData={reportItem}
                    icon={<AssessmentSharp />}
                  />
                </>
              ) : userContext.user?.Role === "Support" ? (
                <>
                  {" "}
                  <DrawerItem
                    itemData={tableItem}
                    icon={<TableRestaurantIcon />}
                  />
                </>
              ): (
                logout()
              )}
            </div>
            {userContext.user !== null ? (
              <Button
                fullWidth
                color="info"
                variant="contained"
                sx={{ fontWeight: "bold" }}
                onClick={logout}
              >
                登出{" "}
              </Button>
            ) : null}
          </List>
        </Drawer>
        <Main open={open}>
          <DrawerHeader />
          <Outlet></Outlet>
        </Main>
      </Box>
    </ThemeProvider>
  );
}
